import React, { useContext, useEffect, useRef, useState } from "react";
import { Sorting } from "../../../../components/Lists/Sorting";
import { Expandable } from "../../../../components/Expandable/Expandable";
import { Tooltip } from "@mui/material";
import { DropdownsProvider } from "../../../../contexts/DropdownsContext";
import Checkbox from "../../../../components/Checkbox/Checkbox";
import "./QuotePrnList.css";
import { QuoteVendorList } from "./QuoteVendorList";
import { getPrnQuoteList } from "../../Services/QuoteService";
import { ResultsNotFound } from "../../../../components/ResultsNotFound/ResultsNotFound";
import Skeleton from "react-loading-skeleton";
import { QuoteOrderContext } from "../../context/QuoteOrderContext";
import { LABELS } from "../../../../globals/globals";
const ribbonColors = ["var(--blue-300)", "var(--green-350)", "#f7931e"];
const defaultColor = "var(--blue-300)";
const ribbon = [{ when: true, label: LABELS.DRAFT }];

export const QuotePrnList = ({ quote }) => {
  const [openSubStates, setOpenSubStates] = useState({});
  const propertyRefs = useRef({});
  const [tooltips, setTooltips] = useState({});
  const listRef = useRef(null);
  const [dataList, setDataList] = useState([]);
  const [loadingQuotes, setLoadingQuotes] = useState(false);
  const didMount = useRef(false);
  const { quoteToOrderList, hasDetailOnDraft, updateInfoList } = useContext(QuoteOrderContext);
  const getSortingOrder = (order) => {
    // setSortingOrder(order);
  };

  useEffect(() => {
    if (quoteToOrderList && quoteToOrderList.length > 0) {
      dataList.forEach((item) => {
        const found = quoteToOrderList.find(
          (quote) =>
            quote.part_request_id === item.part_request_id &&
            item.quote_request_id === quote.quote_request_id && item.part_id === quote.part_id
        );
        if (found) {
          item.hasVendorSelected = true;
        } else {
          item.hasVendorSelected = false;
        }
      });
      setDataList([...dataList]);
    } else {
      dataList.forEach((item) => {
        item.hasVendorSelected = false;
      });
      setDataList([...dataList]);
    }
  }, [quoteToOrderList]);
  const handleScroll = (event) => {
    const { scrollTop, clientHeight, scrollHeight } = event.currentTarget;
    if (scrollHeight - (scrollTop + 3) <= clientHeight) {
      // if (!setLoadingPartsReq) requestNextPage();
    }
  };

  const toggleOpenSubState = (aircraftId, open) => {
    closeAllOpenSubStates();
    setTimeout(() => {
      setOpenSubStates((prevState) => ({
        ...prevState,
        [aircraftId]: open,
      }));
    }, 100);
  };
  const closeAllOpenSubStates = () => {
    setOpenSubStates((prevState) => {
      const newState = {};
      Object.keys(prevState).forEach((key) => {
        newState[key] = false;
      });
      return newState;
    });
  };
  useEffect(() => {
    const newTooltips = {};
    Object.entries(propertyRefs.current).forEach(([key, el]) => {
      if (el) {
        newTooltips[key] = el.scrollWidth > el.clientWidth;
      }
    });
    setTooltips(newTooltips);
    if (quote) {
      setLoadingQuotes(true);
      getPrnQuoteList(quote.id)
        .then((response) => {
          setLoadingQuotes(false);
          if (response.data.responseCode === 200) {
            let inventoryArray = response.data.load.map((item) => {
              return {
                ...item,
                date_request_required: item.date_request_required.split("T")[0],
              };
            });
            if (quoteToOrderList && quoteToOrderList.length > 0) {
              inventoryArray = inventoryArray.map((item) => {
                const found = quoteToOrderList.find(
                  (quote) =>
                    quote.part_request_id === item.part_request_id &&
                    item.quote_request_id === quote.quote_request_id
                );
                return {
                  ...item,
                  hasVendorSelected: !!found,
                };
              });
            }
            setDataList(inventoryArray);
          }
        })
        .catch((error) => {
          setLoadingQuotes(false);
          console.error("Error fetching PRN quote list:", error);
        });
    }
  }, []);

  useEffect(() => {
    if (!didMount.current) {
      didMount.current = true;
      return;
    }

    if (quote) {
      getPrnQuoteList(quote.id)
        .then((response) => {
          if (response.data.responseCode === 200) {
            let inventoryArray = response.data.load.map((item) => {
              return {
                ...item,
                date_request_required: item.date_request_required.split("T")[0],
              };
            });
            if (quoteToOrderList && quoteToOrderList.length > 0) {
              inventoryArray = inventoryArray.map((item) => {
                const found = quoteToOrderList.find(
                  (quote) =>
                    quote.part_request_id === item.part_request_id &&
                    item.quote_request_id === quote.quote_request_id
                );
                return {
                  ...item,
                  hasVendorSelected: !!found,
                };
              });
            }
            setDataList(inventoryArray);
          }
        })
        .catch((error) => {
          console.error("Error fetching PRN quote list:", error);
        });
    }
  }, [updateInfoList]);

 
  return (
    <div className="quote-tracking-list-prn-container">
      <div className="sorting-header">
        <div className="sorting-free-slot"> </div>
        <Sorting
          onOrderChange={getSortingOrder}
          ignoreProperties={true}
          displayButton={false}
        showHeaderOrder={true}
          initialSort="date_request_required"
          properties={{
            id: "PRN",
            part_number: "PN",
            required: "Location",
            issued: "Site",
            available: "QTY Required",
            remaining: "Company",
            vendorResponse: "Vendor Response",
            pendingOrder: "Required Date",
          }}
        ></Sorting>
      </div>
      <div className="quote-list" ref={listRef} onScroll={handleScroll}>
        {loadingQuotes ? (
          Array.from({ length: 7 }).map((_, idx) => (
            <div key={idx} className="item-container-skeleton">
              <Skeleton
                style={{ borderRadius: "10px" }}
                height="1.68rem"
                width={40}
              />
              <div className="item-skeleton-content">
                <Skeleton height={20} width="80%" />
              </div>
              <Skeleton height={30} width="7rem" />
            </div>
          ))
        ) : dataList.length === 0 ? (
          <ResultsNotFound />
        ) : (
          dataList.map((item, idx) => (
            <Expandable
              key={`${item?.id}-${idx}-prn-list`}
              name={`${item?.id}-pen-list-${idx}`}
              summary={
                <React.Fragment key={`${item.id}-${idx}-prn`}>
                  <div
                    className={`item-quote-prn-container ${
                      openSubStates[item?.id] ? "active" : ""
                    } ${item?.hasVendorSelected ? "selected" : ""}`}
                  >
                    {ribbon &&
                      hasDetailOnDraft(
                        item.quote_request_id,
                        item.part_request_id,
                        false
                      ) && (
                        <div className="ribbons-container">
                          {ribbon
                            .filter?.((r) => r.when)
                            ?.map?.((r, i, a) => (
                              <span
                                className="ribbon"
                                key={r.label}
                                style={{
                                  backgroundColor:
                                    r.color ??
                                    ribbonColors[i % ribbonColors.length] ??
                                    defaultColor,
                                  left:
                                    i < a.length - 1
                                      ? `${-0.5 * (ribbon.length - 1 - i)}rem`
                                      : "",
                                }}
                              >
                                {r.label}
                              </span>
                            ))}
                        </div>
                      )}
                    {/* <PartImage item={item} /> */}
                    {[
                      "part_request_id",
                      "part_number",
                      "code",
                      "site_code",
                      "quantity_required",
                      "company_name",
                      "quoted_status_summary",
                      "date_request_required",
                    ].map((label) => (
                      <div
                        className={`property ${
                          label === "quantity_required" ||
                          label === "date_request_required"
                            ? "centerItem"
                            : ""
                        }`}
                        key={label}
                      >
                        <Tooltip
                          title={
                            tooltips[`${item.id}-${label}`] ? item[label] : ""
                          }
                          arrow
                        >
                          {label == "quantity_required" ||
                          label == "date_request_required" ||
                          label == "quoted_status_summary" ? (
                            <p
                              className="bold-font"
                              ref={(el) => {
                                if (el) {
                                  propertyRefs.current[`${item.id}-${label}`] =
                                    el;
                                }
                              }}
                            >
                              {label == "quantity_required"
                                ? item[label] + " " + item["uom_abrevation"]
                                : item[label]}
                            </p>
                          ) : label == "company" ? (
                            <p
                              className="light-font"
                              style={{ marginLeft: "2vw" }}
                              ref={(el) => {
                                if (el) {
                                  propertyRefs.current[`${item.id}-${label}`] =
                                    el;
                                }
                              }}
                            >
                              {item[label]}
                            </p>
                          ) : (
                            <p
                              className="light-font"
                              ref={(el) => {
                                if (el) {
                                  propertyRefs.current[`${item.id}-${label}`] =
                                    el;
                                }
                              }}
                            >
                              {item[label]}
                            </p>
                          )}
                        </Tooltip>
                      </div>
                    ))}
                  </div>
                </React.Fragment>
              }
              isOpen={openSubStates[item?.id]}
              onToggle={(open) => toggleOpenSubState(item?.id, open)}
            >
              {openSubStates[item?.id] && (
                <DropdownsProvider>
                  <QuoteVendorList
                    quote={quote}
                    prn={item}
                    cant={item.quantity_required}
                  ></QuoteVendorList>
                </DropdownsProvider>
              )}
            </Expandable>
          ))
        )}
      </div>
    </div>
  );
};
